import { render, staticRenderFns } from "./AdminSocietesView.vue?vue&type=template&id=48959714&scoped=true"
import script from "./AdminSocietesView.vue?vue&type=script&lang=js"
export * from "./AdminSocietesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48959714",
  null
  
)

export default component.exports